import { UserCarouselSlug } from 'api/userCarousels/types'
import { useTranslation } from 'services/i18n'

import type { FC } from 'react'

type Props = {
  carouselSlug: UserCarouselSlug
}

export const ReadMoreButton: FC<Props> = ({ carouselSlug }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_carousels',
  })

  return (
    <a
      className="kui-btn-plain"
      href={t(`carousels.${carouselSlug}.read_more_url`)}
      target="_blank"
      type="plain"
      rel="noreferrer"
    >
      {t('read_more_label')}
    </a>
  )
}
